import * as Yup from 'yup';

const templateSubject = Yup.string()
  .trim()
  .required('Email subject is required');

export default templateSubject;
